import jQuery from 'jquery';
import { accordion as bindAcccordion } from 'rp-gui-guide';
import fetchOddsTable from './helpers/fetchOddsTable';
import createAccordion from './helpers/createAccordion';
import createLsHelper from './helpers/createLsHelper';
import hideNavTab from './helpers/hideNavTab';
import initOdds from '../oddsTabHandler';

const isAccordionOpen = $header => $header.hasClass('ui-accordion__header_active');

const variant1or2 = (v) => {
    hideNavTab();
    const selector = `.js-odds-variant${v}`;
    const $wrapper = jQuery(selector);

    if (!$wrapper.length) { return; }

    const lsHelper = createLsHelper(selector, true);

    fetchOddsTable().then((oddsTable) => {
        $wrapper.html(createAccordion(oddsTable));
        bindAcccordion(selector);
        initOdds();

        const $header = $wrapper.find('.js-accordion__header');
        if (lsHelper.get()) { $header.trigger('click'); }
        $wrapper.on('click', $header, () => lsHelper.set(isAccordionOpen($header)));
    });
};


export const variant1 = () => variant1or2(1);
export const variant2 = () => variant1or2(2);




// WEBPACK FOOTER //
// ./lib/js/modules/odds/variant1-2.js